var util = require("./util");
var colorUtil = require("./colors");
var a11y = require("./a11y");
var defaultFont = "helvetica";
function PDFText(options, textArr) {
    if (Array.isArray(options) || typeof options === "string") {
        textArr = options;
        options = {};
    }
    if (typeof textArr === "string") {
        textArr = [textArr];
    }
    options = options || {};
    this.text = textArr || [];
    // TODO: validate the inputs
    this.size = util.getOption(options, "size", 16);
    this.font = util.getOption(options, "font", defaultFont);
    this.italic = util.getOption(options, "italic", false);
    this.bold = util.getOption(options, "bold", false);
    this.spacing = util.getOption(options, "spacing", 0);
    this.color = util.getOption(options, "color", "black");
    this.align = util.getOption(options, "align", "left");
    this.lineHeight = util.getOption(options, "lineHeight", 1);
    this.role = util.getOption(options, "role", "p");
    this.ascender = 0.75; // TODO: Fix this. This is specific to Helvetica
    this.transform = util.getOption(options, "transform", "none").toLowerCase();
    this.letterSpacing = util.getOption(options, "letterSpacing", 0);
    this.avoidBreakBefore = util.getOption(options, "avoidBreakBefore", false);
    this.overflowWrap = util.getOption(options, "overflowWrap", "normal");
    this.wordWrap = util.getOption(options, "wordWrap", "normal");
    this.lang = util.getOption(options, "lang", null);
    for (var i = 0; i < this.text.length; i++) {
        if (typeof this.text[i] === "string")
            this.text[i] = { text: this.text[i] };
        this.chunkStyles(this.text[i]);
    }
    this.cache = new util.CalcCache();
}
PDFText.setDefaultFont = function (font) {
    defaultFont = font;
};
PDFText.prototype.invalidate = function () {
    this.cache.clear();
};
PDFText.prototype.chunkStyles = function (chunk) {
    chunk.size = util.getOption(chunk, "size", this.size);
    chunk.font = util.getOption(chunk, "font", this.font);
    chunk.lineHeight = util.getOption(chunk, "lineHeight", this.lineHeight);
    chunk.italic = util.getOption(chunk, "italic", this.italic);
    chunk.bold = util.getOption(chunk, "bold", this.bold);
    chunk.color = util.getOption(chunk, "color", this.color);
    chunk.verticalAlign = util.getOption(chunk, "verticalAlign", "baseline");
    chunk.href = util.getOption(chunk, "href", null);
    chunk.transform = util.getOption(chunk, "transform", this.transform).toLowerCase();
    chunk.letterSpacing = util.getOption(chunk, "letterSpacing", this.letterSpacing);
    chunk.style = "normal";
    if (chunk.bold && chunk.italic)
        chunk.style = "bolditalic";
    else if (chunk.bold)
        chunk.style = "bold";
    else if (chunk.italic)
        chunk.style = "italic";
    //chunk.text = chunk.text || "";
    if (typeof chunk.text === "undefined")
        chunk.text = "";
    if (chunk.transform === "uppercase")
        chunk.text = chunk.text.toLocaleUpperCase();
    if (chunk.transform === "lowercase")
        chunk.text = chunk.text.toLocaleLowerCase();
};
PDFText.prototype.newLine = function () {
    return {
        lineHeight: null,
        width: 0,
        size: this.size,
        chunks: [],
    };
};
var whiteSpaceRegExp = /[ \f\n\r\t\v\u1680\u180e\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]/;
function splitString(str) {
    var arr = [], word = "", lastWasWhite = false;
    for (var i = 0; i < str.length; i++) {
        var char = str.charAt(i);
        if (whiteSpaceRegExp.test(char)) {
            if (!lastWasWhite) {
                arr.push(word);
                word = "";
            }
            lastWasWhite = true;
        }
        else {
            lastWasWhite = false;
            word += char;
        }
    }
    arr.push(word);
    return arr;
}
function getStringWidth(doc, txt, size, letterSpacing) {
    var extraSpacing = isNaN(letterSpacing) ? 0 : letterSpacing * txt.length;
    return doc.getStringUnitWidth(txt) * size + extraSpacing;
}
PDFText.prototype.splitLines = function (cursor) {
    var textArr = this.text.slice(0);
    var that = this, maxWidth = cursor.width, doc = cursor.doc, lines = [], currentLine, remainingWidth = maxWidth;
    textArr.forEach(function (chunk) {
        if (!currentLine) {
            currentLine = that.newLine();
            lines.push(currentLine);
        }
        if (chunk.isInlineBlock && chunk.isInlineBlock()) {
            var inlineBlockCalc = chunk.calc(cursor);
            chunk.width = inlineBlockCalc.width;
            chunk.height = inlineBlockCalc.height;
            chunk.baseline = inlineBlockCalc.baseline;
            if (inlineBlockCalc.width > remainingWidth) {
                currentLine = that.newLine();
                lines.push(currentLine);
                currentLine.chunks.push(chunk);
                remainingWidth = maxWidth - inlineBlockCalc.width;
                currentLine.width = inlineBlockCalc.width;
                if (remainingWidth <= 0) {
                    currentLine = that.newLine();
                    remainingWidth = maxWidth;
                    currentLine.width = 0;
                }
            }
            else {
                currentLine.chunks.push(chunk);
                remainingWidth -= inlineBlockCalc.width;
                currentLine.width = maxWidth - remainingWidth;
            }
        }
        else {
            doc.setFont(chunk.font, chunk.style);
            var lineWidth = getStringWidth(doc, chunk.text, chunk.size, chunk.letterSpacing);
            if (lineWidth > remainingWidth) {
                var split = splitString(chunk.text), //chunk.text.split(/\s+/g),
                newChunk;
                newChunk = util.cloneObj(chunk);
                newChunk.text = "";
                newChunk.width = 0;
                currentLine.chunks.push(newChunk);
                split.forEach(function (word, i) {
                    var newText = i === 0 ? word : newChunk.text + " " + word;
                    lineWidth = getStringWidth(doc, newText, chunk.size, chunk.letterSpacing);
                    if (lineWidth > remainingWidth) {
                        currentLine.width = maxWidth - remainingWidth + newChunk.width;
                        remainingWidth = maxWidth;
                        currentLine = that.newLine();
                        lines.push(currentLine);
                        newChunk = util.cloneObj(chunk);
                        newChunk.text = word;
                        lineWidth = getStringWidth(doc, word, chunk.size, chunk.letterSpacing);
                        newChunk.width = lineWidth;
                        currentLine.chunks.push(newChunk);
                        if (that.overflowWrap === "break-word" || that.wordWrap === "break-word") {
                            while (lineWidth > remainingWidth) {
                                var n, wordWidth;
                                for (n = 0; i < word.length; n++) {
                                    wordWidth = lineWidth = getStringWidth(doc, word.substring(0, n + 1), chunk.size, chunk.letterSpacing);
                                    if (wordWidth > remainingWidth)
                                        break;
                                }
                                if (n === 0)
                                    break;
                                newChunk.text = word.substring(0, n);
                                newChunk.width = getStringWidth(doc, newChunk.text, chunk.size, chunk.letterSpacing);
                                word = word.substring(n);
                                currentLine = that.newLine();
                                lines.push(currentLine);
                                newChunk = util.cloneObj(chunk);
                                newChunk.text = word;
                                lineWidth = getStringWidth(doc, word, chunk.size, chunk.letterSpacing);
                                newChunk.width = lineWidth;
                                currentLine.chunks.push(newChunk);
                            }
                        }
                    }
                    else {
                        newChunk.text = newText;
                        newChunk.width = lineWidth;
                    }
                });
                remainingWidth -= lineWidth;
                currentLine.width = maxWidth - remainingWidth;
            }
            else {
                currentLine.chunks.push(chunk);
                chunk.width = lineWidth;
                remainingWidth -= lineWidth;
                currentLine.width = maxWidth - remainingWidth;
            }
        }
    });
    lines.forEach(function (line) {
        var top = 0, bottom = 0, height = 0;
        line.chunks.forEach(function (chunk) {
            var parentSize = line.size || chunk.size, // parentStyles.size should always be defined, but this is safe
            parentAscent = parentSize * that.ascender, lineHeight, ascent, descent;
            if (chunk.isInlineBlock && chunk.isInlineBlock()) {
                lineHeight = chunk.height;
                if (typeof chunk.baseline === "number")
                    ascent = chunk.baseline;
                else
                    ascent = lineHeight;
            }
            else {
                lineHeight = chunk.lineHeight * chunk.size;
                ascent = lineHeight * that.ascender;
            }
            descent = lineHeight - ascent;
            var vAlignType = (chunk._vAlignType = chunk.verticalAlign);
            if (!vAlignType)
                vAlignType = chunk._vAlignType = "baseline";
            else if (typeof vAlignType === "number")
                vAlignType = chunk._vAlignType = "length";
            // TODO - percentage
            var dBaseline;
            switch (vAlignType) {
                case "length":
                    top = Math.max(ascent + chunk.verticalAlign, top);
                    bottom = Math.max(descent - chunk.verticalAlign, bottom);
                    height = Math.max(height, top - bottom);
                    break;
                // TODO - percentage
                case "top":
                case "bottom":
                    height = Math.max(height, lineHeight);
                    break;
                case "sub": // TODO - needs parent size
                    dBaseline = parentSize * 0.2;
                    top = Math.max(ascent - dBaseline, top);
                    bottom = Math.max(descent + dBaseline, bottom);
                    height = Math.max(height, lineHeight);
                    break;
                case "super": // TODO - needs parent size
                    dBaseline = parentSize * -0.45;
                    top = Math.max(ascent - dBaseline, top);
                    bottom = Math.max(descent + dBaseline, bottom);
                    height = Math.max(height, lineHeight);
                    break;
                case "middle": // TODO - needs parent size
                    top = Math.max((chunk.size + parentAscent) / 2, top);
                    bottom = Math.max((chunk.size - parentAscent) / 2, bottom);
                    height = Math.max(height, lineHeight);
                    break;
                case "baseline":
                    top = Math.max(ascent, top);
                    bottom = Math.max(descent, bottom);
                    height = Math.max(height, lineHeight);
                    break;
            }
        });
        height = Math.max(height, top + bottom);
        if (typeof line.lineHeight === "number")
            height = line.lineHeight;
        var extra = (height - (top + bottom)) / 2;
        line.chunks.forEach(function (chunk) {
            var parentSize = line.size || chunk.size, // parentStyles.size should always be defined, but this is safe
            lineHeight, ascent, descent, parentAscent = parentSize * that.ascender, dy;
            if (chunk.isInlineBlock && chunk.isInlineBlock()) {
                lineHeight = chunk.height;
                if (typeof chunk.baseline === "number")
                    ascent = chunk.baseline;
                else
                    ascent = lineHeight;
            }
            else {
                lineHeight = chunk.lineHeight * chunk.size;
                ascent = lineHeight * that.ascender;
            }
            descent = lineHeight - ascent;
            var dBaseline;
            switch (chunk._vAlignType) {
                case "length":
                    dy = extra + top + chunk.verticalAlign;
                    break;
                // TODO - percentage
                case "top":
                    dy = ascent;
                    break;
                case "bottom":
                    dy = height - descent;
                    break;
                case "sub":
                    dBaseline = parentSize * 0.2;
                    dy = top + extra + dBaseline;
                    break;
                case "super":
                    dBaseline = parentSize * -0.45;
                    dy = top + extra + dBaseline;
                    break;
                case "middle":
                    dy = top + extra - parentAscent / 2 - lineHeight / 2 + ascent;
                    break;
                case "baseline":
                    dy = top + extra;
                    break;
            }
            chunk.dy = dy;
            chunk.ascent = ascent;
            chunk.descent = descent;
        });
        line.baseline = extra + top;
        line.lineHeight = height;
    });
    return lines.filter(function (line) {
        if (line.chunks.filter(function (chunk) { return chunk.isInlineBlock && chunk.isInlineBlock(); }).length > 0)
            return true;
        return line.chunks.map(function (chunk) { return chunk.text; }).join("").length > 0;
    });
};
function hashCursor(cursor) {
    return cursor.width;
}
PDFText.prototype.calc = function (cursor) {
    if (this.cache.has(hashCursor(cursor)))
        return this.cache.get(hashCursor(cursor));
    var lines = this.splitLines(cursor), //cursor.width, cursor.doc),
    that = this;
    var baseline;
    var firstBaseline;
    var height = 0;
    lines.forEach(function (line, i) {
        if (typeof firstBaseline !== "number")
            firstBaseline = line.baseline;
        baseline = baseline ? line.baseline : height + line.baseline;
        height += line.lineHeight;
        if (i !== lines.length - 1)
            height += that.spacing;
    });
    var width = cursor.width;
    if (height === 0)
        width = 0;
    else if (lines.length === 1)
        width = lines[0].width + 1;
    var ret = {
        width: width,
        height: height,
        baseline: baseline,
        firstBaseline: firstBaseline,
    };
    this.cache.set(hashCursor(cursor), ret);
    return ret;
};
PDFText.prototype.draw = function (cursor) {
    var x = cursor.x, y = cursor.y, doc = cursor.doc, height = 0, lines = this.splitLines(cursor), that = this;
    var baseline;
    var firstBaseline;
    var fn = function () {
        lines.forEach(function (line, i) {
            var left = x;
            if (that.align === "center")
                left = x + cursor.width / 2 - line.width / 2;
            if (that.align === "right")
                left = x + cursor.width - line.width;
            line.chunks.forEach(function (chunk, i) {
                var isLastChunkOnLine = i === line.chunks.length - 1;
                var markedOptions = {};
                if (chunk.lang)
                    markedOptions.lang = chunk.lang;
                if (chunk.isInlineBlock && chunk.isInlineBlock()) {
                    if (typeof chunk.href === "string") {
                        a11y.structure(cursor, "link", { alt: chunk.text }, function () {
                            chunk.draw({
                                x: left,
                                y: y + chunk.dy - chunk.ascent,
                                width: chunk.width,
                                height: chunk.height,
                                doc: cursor.doc,
                            });
                            a11y.link(cursor, left, y + chunk.dy - chunk.ascent, chunk.width, chunk.height, {
                                url: chunk.href,
                                alt: chunk.text,
                            });
                        });
                    }
                    else {
                        chunk.draw({
                            x: left,
                            y: y + chunk.dy - chunk.ascent,
                            width: chunk.width,
                            height: chunk.height,
                            doc: cursor.doc,
                        });
                    }
                    if (isLastChunkOnLine) {
                        a11y.marked(cursor, function () {
                            doc.setFont(chunk.font, chunk.style);
                            doc.text(" ", left + chunk.width, y + chunk.height); // Required to add a space for a11y
                        }, null);
                    }
                }
                else {
                    doc.setFont(chunk.font, chunk.style);
                    doc.setFontSize(chunk.size);
                    doc.setTextColor.apply(doc, colorUtil.getRGB(chunk.color));
                    var txt = isLastChunkOnLine ? chunk.text + " " : chunk.text;
                    txt = txt.replace(/[\u00A0]/g, " ");
                    if (typeof chunk.href === "string") {
                        a11y.structure(cursor, "link", { alt: chunk.text }, function () {
                            a11y.marked(cursor, function () {
                                doc.text(txt, left, y + chunk.dy, { charSpace: chunk.letterSpacing });
                            }, markedOptions);
                            a11y.link(cursor, left, y + chunk.dy - chunk.ascent, chunk.width, chunk.ascent + chunk.descent, {
                                url: chunk.href,
                                alt: chunk.text,
                            });
                        });
                    }
                    else if (typeof chunk.role === "string") {
                        a11y.structure(cursor, chunk.role, {
                            title: chunk.title,
                            lang: chunk.lang,
                            alt: chunk.alt,
                            expanded: chunk.expanded,
                            actualText: chunk.actualText,
                        }, function () {
                            a11y.marked(cursor, function () {
                                doc.text(txt, left, y + chunk.dy, { charSpace: chunk.letterSpacing });
                            }, markedOptions);
                        });
                    }
                    else {
                        a11y.marked(cursor, function () {
                            doc.text(txt, left, y + chunk.dy, { charSpace: chunk.letterSpacing });
                        }, markedOptions);
                    }
                    if (chunk.underline) {
                        a11y.artifact(cursor, function () {
                            var underlinePosition = y + chunk.dy + chunk.size * 0.1;
                            var underlineWidth = chunk.size * 0.04;
                            doc.setDrawColor.apply(doc, colorUtil.getRGB(chunk.color));
                            doc.rect(left, underlinePosition, chunk.width, underlineWidth, "F");
                        });
                    }
                }
                left += chunk.width;
            });
            y += line.lineHeight + that.spacing;
            if (typeof firstBaseline !== "number")
                firstBaseline = line.baseline;
            baseline = baseline ? line.baseline : height + line.baseline;
            height += line.lineHeight;
            if (i !== lines.length - 1)
                height += that.spacing;
        });
    };
    if (doc.__a11yStructParent)
        fn();
    else
        a11y.structure(cursor, this.role || "p", { lang: this.lang }, fn, this);
    return {
        width: cursor.width,
        height: height,
        baseline: baseline,
        firstBaseline: firstBaseline,
    };
};
module.exports = PDFText;
//# sourceMappingURL=module.js.map